/* Fiuto — movimento: entrate delle sezioni, pista dei croccantini, capitoli impilati, microinterazioni. Nessuna libreria. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* 1. Entrate delle sezioni */
  var io = null;
  function inView(el) { var r = el.getBoundingClientRect(); return r.top < window.innerHeight * 0.92 && r.bottom > 0; }
  function tagGrid(scope) {
    (scope || d).querySelectorAll('.product-grid__item, .resource-list__item').forEach(function (li, i) {
      if (li.hasAttribute('data-fi-reveal')) return;
      if (inView(li)) return; /* quello che si vede subito non si nasconde */
      li.setAttribute('data-fi-reveal', 'rise');
      li.style.setProperty('--fi-i', String(i % 4));
    });
  }
  function initReveal(scope) {
    var els = Array.prototype.slice.call((scope || d).querySelectorAll('[data-fi-reveal]:not(.is-in), .fi-chapter:not(.is-in)'));
    if (reduce || !hasIO) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          (en.target.__fiTargets || [en.target]).forEach(function (t) { t.classList.add('is-in'); });
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
    }
    els.forEach(function (e) {
      if (inView(e) && !e.classList.contains('fi-chapter')) { e.classList.add('is-in'); return; }
      /* un elemento ritagliato (clip-path) non risulta visibile all'osservatore: osservo il suo contenitore */
      var target = e.getAttribute('data-fi-reveal') === 'clip' && e.parentElement ? e.parentElement : e;
      (target.__fiTargets = target.__fiTargets || []).push(e);
      io.observe(target);
    });
  }

  /* 2. La pista dei croccantini nella prima schermata */
  function initHero(sec) {
    if (sec.__fi) return; sec.__fi = true;
    var plate = sec.querySelector('[data-fi-plate]');
    var replay = sec.querySelector('[data-fi-replay]');
    var motions = Array.prototype.slice.call(sec.querySelectorAll('.fi-kibble animateMotion'));
    if (!plate || !motions.length || typeof motions[0].beginElement !== 'function') {
      if (replay) replay.hidden = true;
      return;
    }
    var busy = false, STEP = 150, DUR = 1500;
    function run() {
      if (busy) return; busy = true;
      motions.forEach(function (m, i) { setTimeout(function () { try { m.beginElement(); } catch (e) {} }, i * STEP); });
      setTimeout(function () {
        plate.classList.remove('is-fed'); void plate.offsetWidth; plate.classList.add('is-fed');
      }, DUR - 120);
      setTimeout(function () { busy = false; }, (motions.length - 1) * STEP + DUR);
    }
    if (reduce) { if (replay) replay.hidden = true; return; }
    setTimeout(run, 950);
    if (replay) replay.addEventListener('click', run);
  }

  /* 3. Capitoli impilati: la scheda coperta si allontana un poco */
  function initStack(sec) {
    if (sec.__fi || reduce) return; sec.__fi = true;
    var cards = Array.prototype.slice.call(sec.querySelectorAll('.fi-chapter'));
    if (cards.length < 2) return;
    var ticking = false, active = false;
    function update() {
      ticking = false;
      for (var i = 0; i < cards.length - 1; i++) {
        var cur = cards[i].getBoundingClientRect(), nxt = cards[i + 1].getBoundingClientRect();
        var p = (cur.bottom - nxt.top) / Math.max(1, cur.height);
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        cards[i].style.setProperty('--fi-depth', p.toFixed(3));
      }
    }
    function onScroll() { if (active && !ticking) { ticking = true; requestAnimationFrame(update); } }
    if (hasIO) new IntersectionObserver(function (e) { active = e[0].isIntersecting; if (active) update(); }).observe(sec);
    else active = true;
    /* su desktop Horizon scorre dentro .page-wrapper: ascolto lo scroll di qualsiasi contenitore */
    d.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
  }

  /* 4. Microinterazioni: varianti, aggiunta al carrello, icona carrello, intestazione */
  var lastAtc = null;
  d.addEventListener('change', function (e) {
    var vp = e.target.closest && e.target.closest('variant-picker');
    if (vp) vp.classList.add('fi-touched');
  });
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.add-to-cart-button');
    if (b) lastAtc = b;
  }, true);
  function cartDone(ok) {
    var b = lastAtc; lastAtc = null;
    if (!ok) return;
    var ic = d.querySelector('cart-icon');
    if (ic && !reduce) { ic.classList.remove('fi-bump'); void ic.offsetWidth; ic.classList.add('fi-bump'); }
    if (b) {
      b.classList.remove('fi-added'); void b.offsetWidth; b.classList.add('fi-added');
      setTimeout(function () { b.classList.remove('fi-added'); }, 900);
    }
  }
  /* Horizon recente: 'shopify:cart:lines-update' con una promise; versioni precedenti: 'cart:update' */
  function onCart(e) {
    if (e.action && e.action !== 'add') return;
    if (e.promise && typeof e.promise.then === 'function') {
      e.promise.then(function (r) { cartDone(!(r && r.detail && r.detail.didError)); }, function () { cartDone(false); });
    } else cartDone(true);
  }
  d.addEventListener('shopify:cart:lines-update', onCart);
  d.addEventListener('cart:update', onCart);
  var scrolled = false, pw = null;
  function onHeaderScroll() {
    pw = pw || d.querySelector('.page-wrapper');
    var y = window.scrollY || (pw ? pw.scrollTop : 0);
    var s = y > 8;
    if (s !== scrolled) { scrolled = s; d.body.classList.toggle('fi-scrolled', s); }
  }
  d.addEventListener('scroll', onHeaderScroll, { passive: true, capture: true });

  function init(scope) {
    tagGrid(scope);
    initReveal(scope);
    (scope || d).querySelectorAll('[data-fi-hero]').forEach(initHero);
    (scope || d).querySelectorAll('[data-fi-stack]').forEach(initStack);
  }

  function boot() {
    tagGrid();
    /* prima di attivare gli stati nascosti, segno come già entrato ciò che è a schermo */
    d.querySelectorAll('[data-fi-reveal]').forEach(function (e) { if (inView(e)) e.classList.add('is-in'); });
    root.classList.add('fi-ready');
    init();
    onHeaderScroll();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  /* Editor Shopify: ricarica sezioni */
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();